import { render, staticRenderFns } from "./select-template.vue?vue&type=template&id=6213f56a&"
import script from "./select-template.vue?vue&type=script&lang=js&"
export * from "./select-template.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports